import { CandidateFilesTab } from '@/features/recruitment/components/candidate-files-tab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/recruitment/candidates_/$id/files')({
  component: FilesTab,
});

function FilesTab() {
  const { id } = Route.useParams();
  return <CandidateFilesTab candidateId={id} />;
}
